import * as React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import Helmet from 'react-helmet'
import { TopMenu } from './TopMenu'
import { Footer } from './Footer'
import { ParallaxProvider } from 'react-scroll-parallax'

type LayoutProps = {
  children: any
  topMenu: any
  activeDocMeta: any
  activeProjectFilter?: any
  setActiveProjectFilter?: any
  categories?: any
}

export const Layout: React.FC<LayoutProps> = ({
  children,
  topMenu,
  activeDocMeta,
  activeProjectFilter,
  setActiveProjectFilter,
  categories,
}) => {
  const queryData = useStaticQuery(graphql`
    query SiteQuery {
      site {
        siteMetadata {
          title
          description
        }
      }
    }
  `)

  // console.log('activeDoc ',activeDocMeta);

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{queryData.site.siteMetadata.title}</title>
        <meta
          name="description"
          content={queryData.site.siteMetadata.description}
        />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <link
          href="https://fonts.googleapis.com/css?family=Lato:300,400,700,900"
          rel="stylesheet"
          type="text/css"
        />
        <link
          href="https://fonts.googleapis.com/icon?family=Material+Icons"
          rel="stylesheet"
        />
      </Helmet>
      <ParallaxProvider>
        <TopMenu
          topMenu={topMenu}
          activeProjectFilter={activeProjectFilter}
          setActiveProjectFilter={setActiveProjectFilter}
          categories={categories}
          activeDocMeta={activeDocMeta}
        />

        <main>{children}</main>
        {/* <Footer /> */}
      </ParallaxProvider>
    </>
  )
}
